// Tasha's Cauldron of Everything Sourcebook
// [FIX APR 2026 sub-project G]: DAMAGE_TYPES enum replaces bare-string compares.
import { DAMAGE_TYPES } from '../../constants/enums';

export const TASHAS_SOURCE = {
  id: 'tashas',
  name: "Tasha's Cauldron of Everything",
  author: 'Wizards of the Coast',
  version: '1.0',
  description: 'A magical mixture of new rules options, subclasses, spells, magic items, and more for D&D 5e',
  enabled: true,
  removable: true,
  builtin: true, // [CW-TRIO-SOURCES 2026-07-12]: shipped sourcebook — excluded from user-content listings
  categories: {
    items: true,
    spells: true,
    feats: true,
    backgrounds: false,
    subclasses: true,  // [FIX JAN 2026]: Enable subclass exposure - 26+ subclasses already defined
    races: false,
    classes: true,     // [CONTENT CREATORS - FEB 2026]: Artificer class
    abilities: true,
    boons: false
  },
  content: {
    items: {
      // Magic Items from Tasha's
      'items_alchemical_compendium': {
        weight: 3, size: [2, 2], baseValue: 6000, icon: '📖',
        name: 'Alchemical Compendium',
        category: 'items',
        description: 'This leather-bound book contains recipes for alchemical items. +2 to spell attacks and DC for spells from this book.',
        requiresAttunement: true,
        rarity: 'rare',
        charges: 3,
        maxCharges: 3,
        chargesPerDay: true,
        rechargeType: 'dawn'
      },
      'items_amulet_of_the_devout': {
        weight: 1, size: [1, 1], baseValue: 4000, icon: '🔮',
        name: 'Amulet of the Devout',
        category: 'items',
        description: 'This amulet bears the symbol of a deity. +1 to spell attack rolls and spell save DC. Can use Channel Divinity one additional time.',
        requiresAttunement: true,
        equipSlot: 'neck',
        rarity: 'uncommon',
        magicalBonus: 1
      },
      'items_arcane_grimoire': {
        weight: 3, size: [2, 2], baseValue: 5000, icon: '📕',
        name: 'Arcane Grimoire',
        category: 'items',
        description: 'This spellbook grants +1 to spell attack rolls and spell save DC when held.',
        requiresAttunement: true,
        rarity: 'uncommon',
        magicalBonus: 1
      },
      'items_astral_shard': {
        weight: 1, size: [1, 1], baseValue: 500, icon: '💎',
        name: 'Astral Shard',
        category: 'items',
        description: 'This crystal allows telepathic communication and can be used as a spellcasting focus for sorcerers.',
        requiresAttunement: true,
        rarity: 'uncommon'
      },
      'items_astromancy_archive': {
        weight: 3, size: [2, 2], baseValue: 12000, icon: '🌟',
        name: 'Astromancy Archive',
        category: 'items',
        description: 'This tome contains knowledge of the cosmos. +2 to spell attacks and DC, and you can cast augury without components.',
        requiresAttunement: true,
        rarity: 'rare',
        spells: [
          { name: 'Augury', charges: 0, level: 2 }
        ]
      },
      'items_atlas_of_endless_horizons': {
        weight: 3, size: [2, 2], baseValue: 11000, icon: '🗺️',
        name: 'Atlas of Endless Horizons',
        category: 'items',
        description: 'This map book contains endless destinations. +2 to spell attacks and DC for ranger spells.',
        requiresAttunement: true,
        rarity: 'rare',
        charges: 3,
        maxCharges: 3,
        chargesPerDay: true,
        rechargeType: 'dawn'
      },
      'items_barrier_tattoo': {
        weight: 0, size: [1, 1], baseValue: 4000, icon: '🎨',
        name: 'Barrier Tattoo',
        category: 'items',
        description: 'This tattoo depicts protective imagery. AC becomes 12 + Dex modifier while not wearing armor.',
        requiresAttunement: true,
        rarity: 'uncommon',
        acBase: 12
      },
      'items_bell_branch': {
        weight: 1, size: [1, 3], baseValue: 600, icon: '🔔',
        name: 'Bell Branch',
        category: 'items',
        description: 'This silver branch has golden bells. Can be used as a druidic focus and grants advantage on performance checks.',
        requiresAttunement: true,
        rarity: 'uncommon'
      },
      'items_bloodwell_vial': {
        weight: 0.5, size: [1, 1], baseValue: 4500, icon: '🩸',
        name: 'Bloodwell Vial',
        category: 'items',
        description: 'This vial contains blood that empowers sorcerers. +1 to spell attacks and DC, regain 5 sorcery points once per day.',
        requiresAttunement: true,
        rarity: 'uncommon',
        magicalBonus: 1,
        charges: 1,
        maxCharges: 1,
        chargesPerDay: true,
        rechargeType: 'dawn'
      },
      'items_cauldron_of_rebirth': {
        weight: 15, size: [3, 3], baseValue: 10000, icon: '🍲',
        name: 'Cauldron of Rebirth',
        category: 'items',
        description: 'After finishing a long rest, you can use this cauldron to create a potion of greater healing.',
        requiresAttunement: true,
        rarity: 'very rare',
        charges: 1,
        maxCharges: 1,
        chargesPerDay: true,
        rechargeType: 'dawn'
      },
      'items_coiling_grasp_tattoo': {
        weight: 0, size: [1, 1], baseValue: 5000, icon: '🐍',
        name: 'Coiling Grasp Tattoo',
        category: 'items',
        description: 'This tattoo has grappling abilities. +1 to unarmed strikes, reach increases by 15 feet.',
        requiresAttunement: true,
        rarity: 'uncommon',
        magicalBonus: 1
      },
      'items_crystalline_chronicle': {
        weight: 3, size: [2, 2], baseValue: 12000, icon: '💠',
        name: 'Crystalline Chronicle',
        category: 'items',
        description: 'This crystal book enhances wizard spells. +2 to spell attacks and DC, and you have +1 to Initiative.',
        requiresAttunement: true,
        rarity: 'very rare',
        magicalBonus: 2,
        bonusInitiative: 1
      },
      'items_devotees_censer': {
        weight: 1, size: [1, 2], baseValue: 4500, icon: '🏺',
        name: "Devotee's Censer",
        category: 'items',
        description: 'This censer amplifies healing. +1 to spell attacks and DC for cleric spells.',
        requiresAttunement: true,
        rarity: 'rare',
        magicalBonus: 1
      },
      'items_duplicitous_manuscript': {
        weight: 3, size: [2, 2], baseValue: 14000, icon: '📜',
        name: 'Duplicitous Manuscript',
        category: 'items',
        description: 'This book of deceptive magic grants +2 to spell attacks and DC for warlock spells.',
        requiresAttunement: true,
        rarity: 'rare',
        magicalBonus: 2
      },
      'items_eldritch_claw_tattoo': {
        weight: 0, size: [1, 1], baseValue: 7000, icon: '✋',
        name: 'Eldritch Claw Tattoo',
        category: 'items',
        description: 'Your unarmed strikes gain +1 to hit and damage, have 15-foot reach, and count as magical.',
        requiresAttunement: true,
        rarity: 'uncommon',
        magicalBonus: 1
      },
      'items_elemental_essence_shard': {
        weight: 0.5, size: [1, 1], baseValue: 4000, icon: '🔥',
        name: 'Elemental Essence Shard',
        category: 'items',
        description: 'This shard contains elemental power. Grants resistance to one damage type (acid, cold, fire, lightning, or thunder).',
        requiresAttunement: true,
        rarity: 'uncommon'
      },
      'items_far_realm_shard': {
        weight: 0.5, size: [1, 1], baseValue: 5000, icon: '👁️',
        name: 'Far Realm Shard',
        category: 'items',
        description: 'This bizarre crystal can be used as a spellcasting focus for sorcerers. You can telepathically speak to creatures.',
        requiresAttunement: true,
        rarity: 'rare'
      },
      'items_feywild_shard': {
        weight: 0.5, size: [1, 1], baseValue: 4500, icon: '🧚',
        name: 'Feywild Shard',
        category: 'items',
        description: 'This vibrant crystal is attuned to the Feywild. Can be used to cast minor illusion without components.',
        requiresAttunement: true,
        rarity: 'uncommon',
        spells: [
          { name: 'Minor Illusion', charges: 0, level: 0 }
        ]
      },
      'items_fulminating_treatise': {
        weight: 3, size: [2, 2], baseValue: 13000, icon: '⚡',
        name: 'Fulminating Treatise',
        category: 'items',
        description: 'This book crackles with power. +2 to spell attacks and DC, ignore resistance to damage from your spells.',
        requiresAttunement: true,
        rarity: 'rare',
        magicalBonus: 2
      },
      'items_ghost_step_tattoo': {
        weight: 0, size: [1, 1], baseValue: 8000, icon: '👻',
        name: 'Ghost Step Tattoo',
        category: 'items',
        description: 'This tattoo allows phasing. 3 charges to become incorporeal for 1 minute.',
        requiresAttunement: true,
        rarity: 'very rare',
        charges: 3,
        maxCharges: 3,
        chargesPerDay: true,
        rechargeType: 'dawn'
      },
      'items_guardian_emblem': {
        weight: 0.5, size: [1, 1], baseValue: 5000, icon: '🛡️',
        name: 'Guardian Emblem',
        category: 'items',
        description: 'This emblem grants divine protection. +1 to spell attacks and DC for paladin spells.',
        requiresAttunement: true,
        rarity: 'uncommon',
        magicalBonus: 1
      },
      'items_heart_weavers_primer': {
        weight: 3, size: [2, 2], baseValue: 12000, icon: '❤️',
        name: "Heart Weaver's Primer",
        category: 'items',
        description: 'This book contains charming magic. +2 to spell attacks and DC for bard spells.',
        requiresAttunement: true,
        rarity: 'rare',
        magicalBonus: 2
      },
      'items_illuminators_tattoo': {
        weight: 0, size: [1, 1], baseValue: 5000, icon: '✨',
        name: "Illuminator's Tattoo",
        category: 'items',
        description: 'This tattoo contains writing magic. You can write with your fingertip, and cast illusory script once per day.',
        requiresAttunement: true,
        rarity: 'common',
        spells: [
          { name: 'Illusory Script', charges: 1, level: 1 }
        ],
        charges: 1,
        maxCharges: 1,
        chargesPerDay: true,
        rechargeType: 'dawn'
      },
      'items_libram_of_souls_and_flesh': {
        weight: 3, size: [2, 2], baseValue: 13000, icon: '📗',
        name: 'Libram of Souls and Flesh',
        category: 'items',
        description: 'This necromantic tome grants +2 to spell attacks and DC, animate dead costs one less spell slot.',
        requiresAttunement: true,
        rarity: 'rare',
        magicalBonus: 2
      },
      'items_luba_talisman': {
        weight: 0.5, size: [1, 1], baseValue: 3000, icon: '🪶',
        name: "Luba's Talisman of Resilience",
        category: 'items',
        description: '+1 to death saving throws, and you have resistance to poison damage.',
        requiresAttunement: true,
        rarity: 'rare'
      },
      'items_masquerade_tattoo': {
        weight: 0, size: [1, 1], baseValue: 3500, icon: '🎭',
        name: 'Masquerade Tattoo',
        category: 'items',
        description: 'This tattoo allows shapeshifting. You can cast disguise self once per day.',
        requiresAttunement: true,
        rarity: 'common',
        spells: [
          { name: 'Disguise Self', charges: 1, level: 1 }
        ],
        charges: 1,
        maxCharges: 1,
        chargesPerDay: true,
        rechargeType: 'dawn'
      },
      'items_mighty_servants_rod': {
        weight: 2, size: [1, 2], baseValue: 18000, icon: '🔱',
        name: 'Rod of the Mighty Servant',
        category: 'items',
        description: 'This rod can summon a powerful construct servant once per week.',
        equipSlot: 'mainhand',
        requiresAttunement: true,
        rarity: 'legendary',
        charges: 1,
        maxCharges: 1,
        rechargeType: 'weekly'
      },
      'items_moon_sickle': {
        weight: 2, size: [1, 2], baseValue: 5000, icon: '🌙',
        name: 'Moon Sickle',
        category: 'weapons',
        description: '+1 sickle that can be used as a spellcasting focus for druids and rangers. +1 to spell attacks and healing spells heal +1d4.',
        requiresAttunement: true,
        rarity: 'uncommon',
        damage: '1d4',
        damageType: 'slashing',
        properties: ['Light'],
        magicalBonus: 1
      },
      'items_natures_mantle': {
        weight: 2, size: [2, 2], baseValue: 6000, icon: '🍃',
        name: "Nature's Mantle",
        category: 'items',
        description: 'This cloak allows you to hide as a bonus action in natural environments. +1 to spell attacks for ranger and druid spells.',
        requiresAttunement: true,
        equipSlot: 'back',
        rarity: 'uncommon',
        magicalBonus: 1
      },
      'items_ouija_board': {
        weight: 2, size: [2, 2], baseValue: 200, icon: '📋',
        name: 'Ouija Board',
        category: 'items',
        description: 'This board allows communication with spirits. Can cast speak with dead once per day.',
        rarity: 'uncommon',
        spells: [
          { name: 'Speak with Dead', charges: 1, level: 3 }
        ],
        charges: 1,
        maxCharges: 1,
        chargesPerDay: true,
        rechargeType: 'dawn'
      },
      'items_planecallers_codex': {
        weight: 3, size: [2, 2], baseValue: 16000, icon: '📘',
        name: "Planecaller's Codex",
        category: 'items',
        description: 'This book contains planar knowledge. +2 to spell attacks and DC, advantage on checks about planes.',
        requiresAttunement: true,
        rarity: 'rare',
        magicalBonus: 2
      },
      'items_protective_verses': {
        weight: 3, size: [2, 2], baseValue: 15000, icon: '📔',
        name: 'Protective Verses',
        category: 'items',
        description: 'This prayer book protects allies. +2 to spell attacks and DC for cleric spells, sanctuary once per day.',
        requiresAttunement: true,
        rarity: 'rare',
        magicalBonus: 2,
        spells: [
          { name: 'Sanctuary', charges: 1, level: 1 }
        ],
        charges: 1,
        maxCharges: 1,
        chargesPerDay: true,
        rechargeType: 'dawn'
      },
      'items_revelers_concertina': {
        weight: 2, size: [2, 1], baseValue: 6000, icon: '🎵',
        name: "Reveler's Concertina",
        category: 'items',
        description: 'This musical instrument enhances charm magic. +2 to spell DC for enchantment spells.',
        requiresAttunement: true,
        rarity: 'rare',
        magicalBonus: 2
      },
      'items_rhythm_makers_drum': {
        weight: 3, size: [2, 2], baseValue: 6500, icon: '🥁',
        name: "Rhythm-Maker's Drum",
        category: 'items',
        description: 'This drum can be used as a spellcasting focus for bards. +1 to spell attacks and regain one use of Bardic Inspiration.',
        requiresAttunement: true,
        rarity: 'uncommon',
        magicalBonus: 1,
        charges: 1,
        maxCharges: 1,
        chargesPerDay: true,
        rechargeType: 'dawn'
      },
      'items_shadowfell_shard': {
        weight: 0.5, size: [1, 1], baseValue: 5500, icon: '🌑',
        name: 'Shadowfell Shard',
        category: 'items',
        description: 'This dark crystal is attuned to the Shadowfell. Grants darkvision 60 feet and can cast minor illusion.',
        requiresAttunement: true,
        rarity: 'rare',
        spells: [
          { name: 'Minor Illusion', charges: 0, level: 0 }
        ]
      },
      'items_spellwrought_tattoo': {
        weight: 0, size: [1, 1], baseValue: 500, icon: '🪄',
        name: 'Spellwrought Tattoo (1st)',
        category: 'items',
        description: 'This tattoo contains a single 1st-level spell that can be cast once.',
        rarity: 'common',
        charges: 1,
        maxCharges: 1,
        rechargeType: 'never'
      },
      'items_wand_of_the_war_mage': {
        weight: 1, size: [1, 2], baseValue: 1200, icon: '⚔️',
        name: 'Wand of the War Mage +1',
        category: 'items',
        description: 'This wand grants +1 to spell attack rolls and ignores half cover.',
        equipSlot: 'mainhand',
        requiresAttunement: true,
        rarity: 'uncommon',
        magicalBonus: 1
      }
    },
    spells: {
      // Tasha's Spells
      'air_bubble': {
        name: "Air Bubble",
        level: 2,
        school: "Conjuration",
        castTime: "1 action",
        range: "60 feet",
        components: "S",
        duration: "24 hours",
        description: "You create a spectral globe around the head of a willing creature you can see within range. The globe is filled with fresh air that lasts until the spell ends. If the creature has more than one head, the globe of air appears around only one of its heads (which head is the creature's choice). The globe of air acts as a helmet that allows the creature to breathe normally in any environment, including underwater or in a vacuum.",
        classes: ["Druid", "Ranger", "Sorcerer", "Wizard"]
      },
      'blade_of_disaster': {
        name: "Blade of Disaster",
        level: 9,
        school: "Conjuration",
        castTime: "1 bonus action",
        range: "60 feet",
        components: "V, S",
        duration: "Concentration, up to 1 minute",
        description: "Create a blade-shaped planar rift that deals 4d12 force damage on hit. Critical on 18-20.",
        damage: "4d12",
        damageType: "force",
        classes: ["Sorcerer", "Warlock", "Wizard"]
      },
      'booming_blade': {
        name: "Booming Blade",
        level: 0,
        school: "Evocation",
        castTime: "1 action",
        range: "Self (5-foot radius)",
        components: "S, M (a melee weapon worth at least 1 sp)",
        duration: "1 round",
        description: "Make a melee attack. On hit, target takes thunder damage if it moves.",
        damage: "1d8",
        damageType: "thunder",
        classes: ["Sorcerer", "Warlock", "Wizard"]
      },
      'dream_of_the_blue_veil': {
        name: "Dream of the Blue Veil",
        level: 7,
        school: "Conjuration",
        castTime: "10 minutes",
        range: "20 feet",
        components: "V, S, M (a magic item or willing creature from the destination world)",
        duration: "6 hours",
        description: "Transport yourself and others to another world or plane.",
        classes: ["Bard", "Sorcerer", "Warlock", "Wizard"]
      },
      'green_flame_blade': {
        name: "Green-Flame Blade",
        level: 0,
        school: "Evocation",
        castTime: "1 action",
        range: "Self (5-foot radius)",
        components: "S, M (a melee weapon worth at least 1 sp)",
        duration: "Instantaneous",
        description: "Make a melee attack. Fire leaps to nearby enemy.",
        damage: "1d8",
        damageType: "fire",
        classes: ["Sorcerer", "Warlock", "Wizard"]
      },
      'intellect_fortress': {
        name: "Intellect Fortress",
        level: 3,
        school: "Abjuration",
        castTime: "1 action",
        range: "30 feet",
        components: "V",
        duration: "Concentration, up to 1 hour",
        description: "Grant resistance to psychic damage and advantage on Int, Wis, and Cha saves.",
        classes: ["Bard", "Sorcerer", "Warlock", "Wizard"]
      },
      'lightning_lure': {
        name: "Lightning Lure",
        level: 0,
        school: "Evocation",
        castTime: "1 action",
        range: "Self (15-foot radius)",
        components: "V",
        duration: "Instantaneous",
        description: "Pull a creature 10 feet toward you. If it ends within 5 feet, it takes lightning damage.",
        damage: "1d8",
        damageType: "lightning",
        saveType: "strength",
        classes: ["Sorcerer", "Warlock", "Wizard"]
      },
      'mind_sliver': {
        name: "Mind Sliver",
        level: 0,
        school: "Enchantment",
        castTime: "1 action",
        range: "60 feet",
        components: "V",
        duration: "1 round",
        description: "Target takes 1d6 psychic damage and -1d4 to next save.",
        damage: "1d6",
        damageType: "psychic",
        saveType: "intelligence",
        classes: ["Sorcerer", "Warlock", "Wizard"]
      },
      'spirit_shroud': {
        name: "Spirit Shroud",
        level: 3,
        school: "Necromancy",
        castTime: "1 bonus action",
        range: "Self",
        components: "V, S",
        duration: "Concentration, up to 1 minute",
        description: "Spirits swirl around you. Your attacks deal extra 1d8 damage.",
        damage: "1d8",
        damageType: "radiant",
        upcastDamage: "1d8",
        classes: ["Cleric", "Paladin", "Warlock", "Wizard"]
      },
      'summon_aberration': {
        name: "Summon Aberration",
        level: 4,
        school: "Conjuration",
        castTime: "1 action",
        range: "90 feet",
        components: "V, S, M (a pickled tentacle and an eyeball in a platinum-inlaid vial worth at least 400 gp)",
        duration: "Concentration, up to 1 hour",
        description: "Summon an aberrant spirit that fights for you.",
        classes: ["Warlock", "Wizard"]
      },
      'summon_beast': {
        name: "Summon Beast",
        level: 2,
        school: "Conjuration",
        castTime: "1 action",
        range: "90 feet",
        components: "V, S, M (a feather, tuft of fur, and fish tail inside a gilded acorn worth at least 200 gp)",
        duration: "Concentration, up to 1 hour",
        description: "Summon a bestial spirit that fights for you.",
        classes: ["Druid", "Ranger"]
      },
      'summon_celestial': {
        name: "Summon Celestial",
        level: 5,
        school: "Conjuration",
        castTime: "1 action",
        range: "90 feet",
        components: "V, S, M (a golden reliquary worth at least 500 gp)",
        duration: "Concentration, up to 1 hour",
        description: "Summon a celestial spirit that fights for you.",
        classes: ["Cleric", "Paladin"]
      },
      'summon_construct': {
        name: "Summon Construct",
        level: 4,
        school: "Conjuration",
        castTime: "1 action",
        range: "90 feet",
        components: "V, S, M (an ornate stone and metal lockbox worth at least 400 gp)",
        duration: "Concentration, up to 1 hour",
        description: "Summon a construct spirit that fights for you.",
        classes: ["Wizard"]
      },
      'summon_elemental': {
        name: "Summon Elemental",
        level: 4,
        school: "Conjuration",
        castTime: "1 action",
        range: "90 feet",
        components: "V, S, M (air, earth, fire, and water inside a gold-inlaid vial worth at least 400 gp)",
        duration: "Concentration, up to 1 hour",
        description: "Summon an elemental spirit that fights for you.",
        classes: ["Druid", "Ranger", "Wizard"]
      },
      'summon_fey': {
        name: "Summon Fey",
        level: 3,
        school: "Conjuration",
        castTime: "1 action",
        range: "90 feet",
        components: "V, S, M (a gilded flower worth at least 300 gp)",
        duration: "Concentration, up to 1 hour",
        description: "Summon a fey spirit that fights for you.",
        classes: ["Druid", "Ranger", "Warlock", "Wizard"]
      },
      'summon_fiend': {
        name: "Summon Fiend",
        level: 6,
        school: "Conjuration",
        castTime: "1 action",
        range: "90 feet",
        components: "V, S, M (humanoid blood inside a ruby vial worth at least 600 gp)",
        duration: "Concentration, up to 1 hour",
        description: "Summon a fiendish spirit that fights for you.",
        classes: ["Warlock", "Wizard"]
      },
      'summon_shadowspawn': {
        name: "Summon Shadowspawn",
        level: 3,
        school: "Conjuration",
        castTime: "1 action",
        range: "90 feet",
        components: "V, S, M (tears inside a gem worth at least 300 gp)",
        duration: "Concentration, up to 1 hour",
        description: "Summon a shadow spirit that fights for you.",
        classes: ["Warlock", "Wizard"]
      },
      'summon_undead': {
        name: "Summon Undead",
        level: 3,
        school: "Necromancy",
        castTime: "1 action",
        range: "90 feet",
        components: "V, S, M (a gilded skull worth at least 300 gp)",
        duration: "Concentration, up to 1 hour",
        description: "Summon an undead spirit that fights for you.",
        classes: ["Warlock", "Wizard"]
      },
      'sword_burst': {
        name: "Sword Burst",
        level: 0,
        school: "Conjuration",
        castTime: "1 action",
        range: "Self (5-foot radius)",
        components: "V",
        duration: "Instantaneous",
        description: "Create a momentary circle of spectral blades. Creatures within 5 feet take damage on failed Dex save.",
        damage: "1d6",
        damageType: "force",
        saveType: "dexterity",
        classes: ["Sorcerer", "Warlock", "Wizard"]
      },
      'tashas_caustic_brew': {
        name: "Tasha's Caustic Brew",
        level: 1,
        school: "Evocation",
        castTime: "1 action",
        range: "Self (30-foot line)",
        components: "V, S, M (a bit of rotten food)",
        duration: "Concentration, up to 1 minute",
        description: "Stream of acid deals 2d4 acid damage per turn.",
        damage: "2d4",
        damageType: "acid",
        saveType: "dexterity",
        upcastDamage: "2d4",
        classes: ["Sorcerer", "Wizard"]
      },
      'tashas_mind_whip': {
        name: "Tasha's Mind Whip",
        level: 2,
        school: "Enchantment",
        castTime: "1 action",
        range: "90 feet",
        components: "V",
        duration: "1 round",
        description: "Target takes 3d6 psychic damage and can't take reactions.",
        damage: "3d6",
        damageType: "psychic",
        saveType: "intelligence",
        classes: ["Sorcerer", "Wizard"]
      },
      'tashas_otherworldly_guise': {
        name: "Tasha's Otherworldly Guise",
        level: 6,
        school: "Transmutation",
        castTime: "1 bonus action",
        range: "Self",
        components: "V, S, M (an object engraved with a symbol of the Outer Planes worth at least 500 gp)",
        duration: "Concentration, up to 1 minute",
        description: "Transform into an otherworldly form with flight, immunities, and extra attacks.",
        classes: ["Sorcerer", "Warlock", "Wizard"]
      }
    },
    // [PHASE 2.1 - NOV 18, 2025]: Converted all prerequisites from text to structured objects
    feats: {
      'artificer_initiate': {
        id: 'artificer_initiate',
        name: "Artificer Initiate",
        description: "You've learned some of an artificer's inventiveness, gaining the following benefits.",
        source: "Tasha's Cauldron of Everything",
        prerequisites: null,
        benefits: [
          "You gain proficiency with one type of artisan's tools of your choice.",
          "You learn one cantrip of your choice from the artificer spell list.",
          "You learn one 1st-level spell of your choice from the artificer spell list. You can cast this spell once per long rest. Intelligence is your spellcasting ability for these spells."
        ],
        // [PHASE 6.1 - NOV 18, 2025]: Full implementation with unified effects schema
        // Proficiency and spells granted via customChoices
        effects: [],
        customChoices: {
          tool: {
            choose: 1,
            from: 'artisan_tools'
          },
          cantrip: {
            choose: 1,
            from: 'artificer_cantrips'
          },
          spell: {
            choose: 1,
            from: 'artificer_1st_level_spells'
          }
        },
        activeAbilities: {
          castArtificerSpell: {
            name: 'Cast Artificer Spell',
            description: 'Cast your chosen 1st-level artificer spell',
            usesPerLongRest: 1,
            actionType: 'varies'
          }
        },
        tags: ['utility', 'magic', 'tool_proficiency', 'spellcasting']
      },
      'chef': {
        id: 'chef',
        name: "Chef",
        description: "Time and effort spent mastering the culinary arts has paid off, granting you the following benefits.",
        source: "Tasha's Cauldron of Everything",
        prerequisites: null,
        benefits: [
          "Increase your Constitution or Wisdom score by 1, to a maximum of 20.",
          "You gain proficiency with cook's utensils if you don't already have it.",
          "As part of a short rest, you can cook special food, provided you have ingredients and cook's utensils on hand. You can prepare enough of this food for a number of creatures equal to 4 + your proficiency bonus. At the end of the short rest, any creature who eats the food and spends one or more Hit Dice to regain hit points regains an extra 1d8 hit points.",
          "With one hour of work or when you finish a long rest, you can cook a number of treats equal to your proficiency bonus. These special treats last 8 hours after being made. A creature can use a bonus action to eat one of those treats to gain temporary hit points equal to your proficiency bonus."
        ],
        // [PHASE 6.2 - NOV 18, 2025]: Full implementation with unified effects schema
        effects: [
          {
            type: 'proficiency',
            target: 'tool',
            value: 'cooks_utensils',
            operation: 'add',
            condition: 'always'
          }
        ],
        abilityScoreIncrease: {
          choice: [
            { con: 1 },
            { wis: 1 }
          ]
        },
        activeAbilities: {
          cookShortRestMeal: {
            name: 'Cook Hearty Meal',
            description: 'During short rest, cook food that grants +1d8 HP when Hit Dice are used',
            actionType: 'short_rest',
            usesPerShortRest: 1
          },
          cookTreats: {
            name: 'Cook Treats',
            description: 'Cook treats that grant temp HP equal to proficiency bonus',
            actionType: 'long_rest',
            uses: 'proficiency_bonus',
            rechargeOn: 'longRest'
          }
        },
        tags: ['utility', 'healing', 'tool_proficiency', 'support']
      },
      'crusher': {
        id: 'crusher',
        name: "Crusher",
        description: "You are practiced in the art of crushing your enemies, granting you the following benefits.",
        source: "Tasha's Cauldron of Everything",
        prerequisites: null,
        benefits: [
          "Increase your Strength or Constitution score by 1, to a maximum of 20.",
          "Once per turn, when you hit a creature with an attack that deals bludgeoning damage, you can move it 5 feet to an unoccupied space, provided the target is no more than one size larger than you.",
          "When you score a critical hit that deals bludgeoning damage to a creature, attack rolls against that creature are made with advantage until the start of your next turn."
        ],
        // [PHASE 6.2 - NOV 18, 2025]: Full implementation with unified effects schema
        effects: [
          {
            type: 'feature',
            operation: 'grant',
            value: 'push_5ft_on_bludgeoning_hit',
            condition: {
              when: 'bludgeoning_damage_hit',
              check: (character, context) => context?.damageType === DAMAGE_TYPES.BLUDGEONING && context?.hit === true
            }
          },
          {
            type: 'feature',
            operation: 'grant',
            value: 'grant_advantage_on_bludgeoning_crit',
            condition: {
              when: 'critical_hit_bludgeoning',
              check: (character, context) => context?.criticalHit === true && context?.damageType === DAMAGE_TYPES.BLUDGEONING
            }
          }
        ],
        abilityScoreIncrease: {
          choice: [
            { str: 1 },
            { con: 1 }
          ]
        },
        tags: ['combat', 'offensive', 'control', 'damage_type:bludgeoning']
      },
      'eldritch_adept': {
        id: 'eldritch_adept',
        name: "Eldritch Adept",
        description: "Studying occult lore, you have unlocked eldritch power within yourself.",
        source: "Tasha's Cauldron of Everything",
        prerequisites: { spellcasting: true },
        benefits: [
          "You learn one Eldritch Invocation option of your choice from the warlock class.",
          "If the invocation has a prerequisite of any kind, you can choose that invocation only if you're a warlock who meets the prerequisite.",
          "Whenever you gain a level, you can replace the invocation with another one from the warlock class."
        ],
        // [PHASE 6.2 - NOV 18, 2025]: Full implementation with unified effects schema
        // Invocation granted via customChoices
        effects: [],
        customChoices: {
          invocation: {
            choose: 1,
            from: 'warlock_invocations'
          }
        },
        tags: ['magic', 'utility', 'warlock', 'versatile']
      },
      'fey_touched': {
        id: 'fey_touched',
        name: "Fey Touched",
        description: "Your exposure to the Feywild's magic has changed you, granting you the following benefits.",
        source: "Tasha's Cauldron of Everything",
        prerequisites: null,
        benefits: [
          "Increase your Intelligence, Wisdom, or Charisma score by 1, to a maximum of 20.",
          "You learn the misty step spell and one 1st-level spell of your choice. The 1st-level spell must be from the divination or enchantment school of magic.",
          "You can cast each of these spells without expending a spell slot. Once you cast either of these spells in this way, you can't cast that spell in this way again until you finish a long rest. You can also cast these spells using spell slots you have of the appropriate level. The spells' spellcasting ability is the ability increased by this feat."
        ],
        // [PHASE 6.3 - NOV 18, 2025]: Full implementation with unified effects schema
        effects: [],
        abilityScoreIncrease: {
          choice: [
            { int: 1 },
            { wis: 1 },
            { cha: 1 }
          ]
        },
        customChoices: {
          spell: {
            choose: 1,
            from: 'divination_or_enchantment_1st_level'
          }
        },
        activeAbilities: {
          castMistyStep: {
            name: 'Cast Misty Step',
            description: 'Cast misty step once per long rest',
            usesPerLongRest: 1,
            actionType: 'bonus'
          },
          castChosenSpell: {
            name: 'Cast Chosen Spell',
            description: 'Cast your chosen divination/enchantment spell once per long rest',
            usesPerLongRest: 1,
            actionType: 'varies'
          }
        },
        tags: ['magic', 'teleportation', 'utility', 'spellcasting']
      },
      'fighting_initiate': {
        id: 'fighting_initiate',
        name: "Fighting Initiate",
        description: "Your martial training has helped you develop a particular style of fighting.",
        source: "Tasha's Cauldron of Everything",
        prerequisites: { proficiencies: ['weapon:martial'] },
        benefits: [
          "You learn one Fighting Style option of your choice from the fighter class.",
          "If you already have a style, the one you choose must be different.",
          "Whenever you reach a level that grants the Ability Score Improvement feature, you can replace this feat's fighting style with another one from the fighter class that you don't have."
        ],
        // [PHASE 6.3 - NOV 18, 2025]: Full implementation with unified effects schema
        // Fighting style effects vary by choice - implemented via customChoices
        effects: [],
        customChoices: {
          fightingStyle: {
            choose: 1,
            from: 'fighter_fighting_styles'
          }
        },
        tags: ['combat', 'defensive', 'offensive', 'versatile']
      },
      'gunner': {
        id: 'gunner',
        name: "Gunner",
        description: "You have a quick hand and keen eye when employing firearms, granting you the following benefits.",
        source: "Tasha's Cauldron of Everything",
        prerequisites: null,
        benefits: [
          "Increase your Dexterity score by 1, to a maximum of 20.",
          "You gain proficiency with firearms.",
          "You ignore the loading property of firearms.",
          "Being within 5 feet of a hostile creature doesn't impose disadvantage on your ranged attack rolls."
        ],
        // [PHASE 6.4 - NOV 18, 2025]: Full implementation with unified effects schema
        effects: [
          {
            type: 'proficiency',
            target: 'weapon',
            value: 'firearms',
            operation: 'add',
            condition: 'always'
          },
          {
            type: 'weaponProperty',
            operation: 'ignore',
            value: 'loading',
            condition: {
              when: 'weapon_has_loading',
              check: (character, context) => context?.weaponProperties?.includes('loading')
            }
          },
          {
            type: 'combatAdvantage',
            target: 'ranged_in_melee',
            operation: 'remove_disadvantage',
            value: true,
            condition: 'always'
          }
        ],
        abilityScoreIncrease: {
          dex: 1
        },
        tags: ['combat', 'offensive', 'ranged', 'firearms']
      },
      'metamagic_adept': {
        id: 'metamagic_adept',
        name: "Metamagic Adept",
        description: "You've learned how to exert your will on your spells to alter how they function.",
        source: "Tasha's Cauldron of Everything",
        prerequisites: {
          spellcasting: true,
          description: "The ability to cast at least one spell"
        },
        benefits: [
          "You learn two Metamagic options of your choice from the sorcerer class. You can use only one Metamagic option on a spell when you cast it, unless the option says otherwise.",
          "You gain 2 sorcery points to spend on Metamagic (these points are added to any sorcery points you have from another source but can be used only on Metamagic). You regain all spent sorcery points when you finish a long rest."
        ],
        // [PHASE 6.4 - NOV 18, 2025]: Full implementation with unified effects schema
        // NOTE: Sorcery points are a resource pool, not a passive effect
        effects: [],
        customChoices: {
          metamagic: {
            choose: 2,
            from: 'sorcerer_metamagic_options'
          }
        },
        activeAbilities: {
          sorceryPoints: {
            name: 'Sorcery Points',
            description: 'You have 2 sorcery points to spend on Metamagic',
            usesPerLongRest: 2,
            actionType: 'varies',
            resourceType: 'sorcery_points'
          }
        },
        tags: ['magic', 'spellcasting', 'sorcerer', 'versatile']
      },
      'piercer': {
        id: 'piercer',
        name: "Piercer",
        description: "You have achieved a penetrating precision in combat, granting you the following benefits.",
        source: "Tasha's Cauldron of Everything",
        prerequisites: null,
        benefits: [
          "Increase your Strength or Dexterity score by 1, to a maximum of 20.",
          "Once per turn, when you hit a creature with an attack that deals piercing damage, you can reroll one of the attack's damage dice, and you must use the new roll.",
          "When you score a critical hit that deals piercing damage to a creature, you can roll one additional damage die when determining the extra piercing damage the target takes."
        ],
        // [PHASE 6.4 - NOV 18, 2025]: Full implementation with unified effects schema
        effects: [
          {
            type: 'feature',
            operation: 'grant',
            value: 'reroll_piercing_damage_die',
            condition: {
              when: 'piercing_damage_hit',
              check: (character, context) => context?.damageType === DAMAGE_TYPES.PIERCING && context?.hit === true
            }
          },
          {
            type: 'feature',
            operation: 'grant',
            value: 'extra_crit_die_piercing',
            condition: {
              when: 'critical_hit_piercing',
              check: (character, context) => context?.criticalHit === true && context?.damageType === DAMAGE_TYPES.PIERCING
            }
          }
        ],
        abilityScoreIncrease: {
          choice: [
            { str: 1 },
            { dex: 1 }
          ]
        },
        tags: ['combat', 'offensive', 'melee', 'ranged', 'piercing']
      },
      'poisoner': {
        id: 'poisoner',
        name: "Poisoner",
        description: "You can prepare and deliver deadly poisons, granting you the following benefits.",
        source: "Tasha's Cauldron of Everything",
        prerequisites: null,
        benefits: [
          "When you make a damage roll that deals poison damage, it ignores resistance to poison damage.",
          "You can apply poison to a weapon or piece of ammunition as a bonus action, instead of an action.",
          "You gain proficiency with the poisoner's kit if you don't already have it. With one hour of work using a poisoner's kit and expending 50 gp worth of materials, you can create a number of doses of potent poison equal to your proficiency bonus. Once applied to a weapon or piece of ammunition, the poison retains its potency for 1 minute or until you hit with the weapon or ammunition. When a creature takes damage from the coated weapon or ammunition, that creature must succeed on a DC 14 Constitution saving throw or take 2d8 poison damage and become poisoned until the end of your next turn."
        ],
        // [PHASE 6.5 - NOV 18, 2025]: Full implementation with unified effects schema
        effects: [
          {
            type: 'proficiency',
            target: 'tool',
            value: 'poisoners_kit',
            operation: 'add',
            condition: 'always'
          },
          {
            type: 'feature',
            operation: 'grant',
            value: 'ignore_poison_resistance',
            condition: {
              when: 'poison_damage',
              check: (character, context) => context?.damageType === DAMAGE_TYPES.POISON
            }
          },
          {
            type: 'feature',
            operation: 'grant',
            value: 'bonus_action_poison_application',
            condition: 'always'
          },
          {
            type: 'feature',
            operation: 'grant',
            value: 'craft_potent_poison',
            condition: 'always'
          }
        ],
        tags: ['utility', 'combat', 'crafting', 'poison']
      },
      'shadow_touched': {
        id: 'shadow_touched',
        name: "Shadow Touched",
        description: "Your exposure to the Shadowfell's magic has changed you, granting you the following benefits.",
        source: "Tasha's Cauldron of Everything",
        prerequisites: null,
        benefits: [
          "Increase your Intelligence, Wisdom, or Charisma score by 1, to a maximum of 20.",
          "You learn the invisibility spell and one 1st-level spell of your choice. The 1st-level spell must be from the illusion or necromancy school of magic.",
          "You can cast each of these spells without expending a spell slot. Once you cast either of these spells in this way, you can't cast that spell in this way again until you finish a long rest. You can also cast these spells using spell slots you have of the appropriate level. The spells' spellcasting ability is the ability increased by this feat."
        ],
        // [PHASE 6.3 - NOV 18, 2025]: Full implementation with unified effects schema
        effects: [],
        abilityScoreIncrease: {
          choice: [
            { int: 1 },
            { wis: 1 },
            { cha: 1 }
          ]
        },
        customChoices: {
          spell: {
            choose: 1,
            from: 'illusion_or_necromancy_1st_level'
          }
        },
        activeAbilities: {
          castInvisibility: {
            name: 'Cast Invisibility',
            description: 'Cast invisibility once per long rest',
            usesPerLongRest: 1,
            actionType: 'action'
          },
          castChosenSpell: {
            name: 'Cast Chosen Spell',
            description: 'Cast your chosen illusion/necromancy spell once per long rest',
            usesPerLongRest: 1,
            actionType: 'varies'
          }
        },
        tags: ['magic', 'stealth', 'utility', 'spellcasting']
      },
      'skill_expert': {
        id: 'skill_expert',
        name: "Skill Expert",
        description: "You have honed your proficiency with particular skills, granting you the following benefits.",
        source: "Tasha's Cauldron of Everything",
        prerequisites: null,
        benefits: [
          "Increase one ability score of your choice by 1, to a maximum of 20.",
          "You gain proficiency in one skill of your choice.",
          "Choose one skill in which you have proficiency. You gain expertise with that skill, which means your proficiency bonus is doubled for any ability check you make with it. The skill you choose must be one that isn't already benefiting from a feature, such as Expertise, that doubles your proficiency bonus."
        ],
        // [PHASE 6.5 - NOV 18, 2025]: Full implementation with unified effects schema
        effects: [],
        abilityScoreIncrease: {
          choice: [
            { str: 1 },
            { dex: 1 },
            { con: 1 },
            { int: 1 },
            { wis: 1 },
            { cha: 1 }
          ]
        },
        customChoices: {
          skillProficiency: {
            choose: 1,
            from: 'all_skills'
          },
          skillExpertise: {
            choose: 1,
            from: 'proficient_skills'
          }
        },
        tags: ['utility', 'skill', 'expertise', 'versatile']
      },
      'slasher': {
        id: 'slasher',
        name: "Slasher",
        description: "You've learned where to cut to have the greatest results, granting you the following benefits.",
        source: "Tasha's Cauldron of Everything",
        prerequisites: null,
        benefits: [
          "Increase your Strength or Dexterity score by 1, to a maximum of 20.",
          "Once per turn when you hit a creature with an attack that deals slashing damage, you can reduce the speed of the target by 10 feet until the start of your next turn.",
          "When you score a critical hit that deals slashing damage to a creature, you grievously wound it. Until the start of your next turn, the target has disadvantage on all attack rolls."
        ],
        // [PHASE 6.5 - NOV 18, 2025]: Full implementation with unified effects schema
        effects: [
          {
            type: 'feature',
            operation: 'grant',
            value: 'reduce_speed_10ft_on_slashing_hit',
            condition: {
              when: 'slashing_damage_hit',
              check: (character, context) => context?.damageType === DAMAGE_TYPES.SLASHING && context?.hit === true
            }
          },
          {
            type: 'feature',
            operation: 'grant',
            value: 'impose_disadvantage_on_slashing_crit',
            condition: {
              when: 'critical_hit_slashing',
              check: (character, context) => context?.criticalHit === true && context?.damageType === DAMAGE_TYPES.SLASHING
            }
          }
        ],
        abilityScoreIncrease: {
          choice: [
            { str: 1 },
            { dex: 1 }
          ]
        },
        tags: ['combat', 'offensive', 'melee', 'control', 'slashing']
      },
      'telekinetic': {
        id: 'telekinetic',
        name: "Telekinetic",
        description: "You learn to move things with your mind, granting you the following benefits.",
        source: "Tasha's Cauldron of Everything",
        prerequisites: null,
        benefits: [
          "Increase your Intelligence, Wisdom, or Charisma score by 1, to a maximum of 20.",
          "You learn the mage hand cantrip. You can cast it without verbal or somatic components, and you can make the spectral hand invisible. If you already know this spell, its range increases by 30 feet when you cast it. Its spellcasting ability is the ability increased by this feat.",
          "As a bonus action, you can try to telekinetically shove one creature you can see within 30 feet of you. When you do so, the target must succeed on a Strength saving throw (DC 8 + your proficiency bonus + the ability modifier of the score increased by this feat) or be moved 5 feet toward or away from you. A creature can willingly fail this save."
        ],
        // [PHASE 6.5 - NOV 18, 2025]: Full implementation with unified effects schema
        effects: [],
        abilityScoreIncrease: {
          choice: [
            { int: 1 },
            { wis: 1 },
            { cha: 1 }
          ]
        },
        customChoices: {
          cantrip: {
            choose: 1,
            from: ['mage_hand'],
            fixed: true
          }
        },
        activeAbilities: {
          telekineticShove: {
            name: 'Telekinetic Shove',
            description: 'Use bonus action to shove a creature 5 feet (Strength save)',
            usesPerTurn: 1,
            actionType: 'bonus',
            saveType: 'strength',
            saveDC: '8_plus_prof_plus_ability'
          }
        },
        tags: ['magic', 'utility', 'control', 'spellcasting']
      },
      'telepathic': {
        id: 'telepathic',
        name: "Telepathic",
        description: "You awaken the ability to mentally connect with others, granting you the following benefits.",
        source: "Tasha's Cauldron of Everything",
        prerequisites: null,
        benefits: [
          "Increase your Intelligence, Wisdom, or Charisma score by 1, to a maximum of 20.",
          "You can speak telepathically to any creature you can see within 60 feet of you. Your telepathic utterances are in a language you know, and the creature understands you only if it knows that language. Your communication doesn't give the creature the ability to respond to you telepathically.",
          "You can cast the detect thoughts spell, requiring no spell slot or components, and you must finish a long rest before you can cast it this way again. Your spellcasting ability for the spell is the ability increased by this feat. If you have spell slots of 2nd level or higher, you can cast this spell with them."
        ],
        // [PHASE 6.5 - NOV 18, 2025]: Full implementation with unified effects schema
        effects: [
          {
            type: 'feature',
            operation: 'grant',
            value: 'telepathic_speech_60ft',
            condition: 'always'
          }
        ],
        abilityScoreIncrease: {
          choice: [
            { int: 1 },
            { wis: 1 },
            { cha: 1 }
          ]
        },
        activeAbilities: {
          castDetectThoughts: {
            name: 'Cast Detect Thoughts',
            description: 'Cast detect thoughts once per long rest',
            usesPerLongRest: 1,
            actionType: 'action'
          }
        },
        tags: ['magic', 'utility', 'communication', 'spellcasting']
      }
    },
    abilities: {
      // Optional Class Features from Tasha's
      'cunning_action_aim': {
        name: "Cunning Action: Aim",
        description: "Rogue: Use bonus action to gain advantage on next attack this turn.",
        class: "Rogue",
        level: 2
      },
      'steady_aim': {
        name: "Steady Aim",
        description: "Rogue: As a bonus action, give yourself advantage on your next attack if you don't move.",
        class: "Rogue",
        level: 3
      },
      'dedicated_weapon': {
        name: "Dedicated Weapon",
        description: "Monk: Choose weapons to be monk weapons if they lack the heavy or special properties.",
        class: "Monk",
        level: 2
      },
      'ki_fueled_attack': {
        name: "Ki-Fueled Attack",
        description: "Monk: If you spend ki on your turn, make one weapon attack as a bonus action.",
        class: "Monk",
        level: 3
      },
      'favored_foe': {
        name: "Favored Foe",
        description: "Ranger: Mark a target when you hit it, dealing extra 1d4 damage once per turn.",
        class: "Ranger",
        level: 1
      },
      'deft_explorer': {
        name: "Deft Explorer",
        description: "Ranger: Gain expertise in one skill, plus additional benefits at higher levels.",
        class: "Ranger",
        level: 1
      },
      'primal_awareness': {
        name: "Primal Awareness",
        description: "Ranger: Cast certain spells once per long rest without using a spell slot.",
        class: "Ranger",
        level: 3
      },
      'blessed_warrior': {
        name: "Blessed Warrior",
        description: "Paladin Fighting Style: Learn two cantrips from the cleric spell list.",
        class: "Paladin",
        level: 2
      },
      'harness_divine_power': {
        name: "Harness Divine Power",
        description: "Cleric/Paladin: Use Channel Divinity to regain a spell slot.",
        class: "Cleric",
        level: 2
      },
      'magical_inspiration': {
        name: "Magical Inspiration",
        description: "Bard: Bardic Inspiration can be used to add to spell damage or healing.",
        class: "Bard",
        level: 2
      }
    },
    // [PHASE 0.4 - NOV 15, 2025]: Tasha's Cauldron of Everything Subclasses
    // [WHY]: User reported "none of the extra warlock subclasses are appearing in the system"
    // [MIGRATION]: From srdCharacterData.js TODO comments to sources system
    // [TOTAL]: 19 subclasses across 11 classes
    subclasses: {
      // ARTIFICER (4 subclasses) - [CONTENT CREATORS - FEB 2026]: Training examples
      'alchemist': {
        name: 'Alchemist',
        class: 'Artificer',
        source: 'tashas',
        level: 3,
        description: 'An Artificer who specializes in using alchemy to produce mystical effects. You become adept at concocting and administering potions and elixirs.',
        features: {
          3: ['Tool Proficiency', 'Alchemist Spells', 'Experimental Elixir'],
          5: ['Alchemical Savant'],
          9: ['Restorative Reagents'],
          15: ['Chemical Mastery']
        },
        featureDescriptions: {
          'Tool Proficiency': "You gain proficiency with alchemist's supplies. If you already have this proficiency, you gain proficiency with one other type of artisan's tools.",
          'Alchemist Spells': 'You always have certain spells prepared at the Artificer levels listed: 3rd - Healing Word, Ray of Sickness; 5th - Flaming Sphere, Melf\'s Acid Arrow; 9th - Gaseous Form, Mass Healing Word; 13th - Blight, Death Ward; 17th - Cloudkill, Raise Dead.',
          'Experimental Elixir': 'Whenever you finish a long rest, you can magically produce an experimental elixir in an empty flask. Roll on the Experimental Elixir table for effect. You can create additional elixirs by expending spell slots.',
          'Alchemical Savant': 'At 5th level, you develop masterful command of magical chemicals. Whenever you cast a spell using alchemist\'s supplies as the spellcasting focus, you gain a bonus equal to your Intelligence modifier to one roll of the spell that restores hit points or deals acid, fire, necrotic, or poison damage.',
          'Restorative Reagents': 'At 9th level, you can incorporate restorative reagents into some of your works. Whenever a creature drinks an experimental elixir you created, the creature gains temporary hit points equal to 2d6 + your Intelligence modifier.',
          'Chemical Mastery': 'At 15th level, you have been exposed to so many chemicals that they pose little risk to you. You gain resistance to acid damage and poison damage, and you are immune to the poisoned condition. You can cast Greater Restoration and Heal without expending a spell slot or material components, once each per long rest.'
        },
        subclassSpells: {
          3: ['Healing Word', 'Ray of Sickness'],
          5: ['Flaming Sphere', "Melf's Acid Arrow"],
          9: ['Gaseous Form', 'Mass Healing Word'],
          13: ['Blight', 'Death Ward'],
          17: ['Cloudkill', 'Raise Dead']
        }
      },
      'armorer': {
        name: 'Armorer',
        class: 'Artificer',
        source: 'tashas',
        level: 3,
        description: 'An Artificer who specializes in modifying armor to function as a second skin. The armor is enhanced to hone your every move.',
        features: {
          3: ['Tools of the Trade', 'Armorer Spells', 'Arcane Armor', 'Armor Model'],
          5: ['Extra Attack'],
          9: ['Armor Modifications'],
          15: ['Perfected Armor']
        }
      },
      'artillerist': {
        name: 'Artillerist',
        class: 'Artificer',
        source: 'tashas',
        level: 3,
        description: 'An Artificer who specializes in using magic to hurl energy, projectiles, and explosions on a battlefield.',
        features: {
          3: ['Tool Proficiency', 'Artillerist Spells', 'Eldritch Cannon'],
          5: ['Arcane Firearm'],
          9: ['Explosive Cannon'],
          15: ['Fortified Position']
        }
      },
      'battle_smith': {
        name: 'Battle Smith',
        class: 'Artificer',
        source: 'tashas',
        level: 3,
        description: 'An Artificer who combines protection and medicine with a steel defender construct that fights alongside you.',
        features: {
          3: ['Tool Proficiency', 'Battle Smith Spells', 'Battle Ready', 'Steel Defender'],
          5: ['Extra Attack'],
          9: ['Arcane Jolt'],
          15: ['Improved Defender']
        }
      },
      // BARBARIAN (2 subclasses)
      'path_of_the_beast': {
        name: 'Path of the Beast',
        class: 'Barbarian',
        source: 'tashas',
        level: 3,
        description: 'Walk the path of a feral warrior, channeling the beast within. You manifest natural weapons and primal adaptations.',
        features: {
          3: ['Form of the Beast', 'Bestial Soul'],
          6: ['Bestial Soul'],
          10: ['Infectious Fury'],
          14: ['Call the Hunt']
        }
      },
      'path_of_wild_magic': {
        name: 'Path of Wild Magic',
        class: 'Barbarian',
        source: 'tashas',
        level: 3,
        description: 'The wild influence of magic has transformed you, suffusing you with arcane power that churns within you.',
        features: {
          3: ['Magic Awareness', 'Wild Surge'],
          6: ['Bolstering Magic'],
          10: ['Unstable Backlash'],
          14: ['Controlled Surge']
        }
      },
      // BARD (2 subclasses)
      'college_of_creation': {
        name: 'College of Creation',
        class: 'Bard',
        source: 'tashas',
        level: 3,
        description: 'Believe in the power of creation and use performance to invoke the magic of creation. You can bring objects and creatures into being.',
        features: {
          3: ['Mote of Potential', 'Performance of Creation'],
          6: ['Animating Performance'],
          14: ['Creative Crescendo']
        }
      },
      'college_of_eloquence': {
        name: 'College of Eloquence',
        class: 'Bard',
        source: 'tashas',
        level: 3,
        description: 'Master the art of oratory. Your carefully chosen words can inspire allies and undermine enemies with equal grace.',
        features: {
          3: ['Silver Tongue', 'Unsettling Words'],
          6: ['Unfailing Inspiration'],
          14: ['Universal Speech']
        }
      },
      // CLERIC (2 subclasses)
      'peace_domain': {
        name: 'Peace Domain',
        class: 'Cleric',
        source: 'tashas',
        level: 1,
        description: 'Embody the tenets of peace and strive to end conflict. You protect and support your allies through harmonious magic.',
        domainSpells: {
          1: ['Heroism', 'Sanctuary'],
          3: ['Aid', 'Warding Bond'],
          5: ['Beacon of Hope', 'Sending'],
          7: ['Aura of Purity', 'Otiluke\'s Resilient Sphere'],
          9: ['Greater Restoration', 'Rary\'s Telepathic Bond']
        },
        features: {
          1: ['Implement of Peace', 'Emboldening Bond'],
          2: ['Channel Divinity: Balm of Peace'],
          6: ['Protective Bond'],
          8: ['Potent Spellcasting'],
          17: ['Expansive Bond']
        }
      },
      'twilight_domain': {
        name: 'Twilight Domain',
        class: 'Cleric',
        source: 'tashas',
        level: 1,
        description: 'Find beauty and comfort in darkness. You bring twilight to your enemies and respite to those who rest beneath your vigil.',
        domainSpells: {
          1: ['Faerie Fire', 'Sleep'],
          3: ['Moonbeam', 'See Invisibility'],
          5: ['Aura of Vitality', 'Leomund\'s Tiny Hut'],
          7: ['Aura of Life', 'Greater Invisibility'],
          9: ['Circle of Power', 'Mislead']
        },
        features: {
          1: ['Bonus Proficiencies', 'Eyes of Night', 'Vigilant Blessing'],
          2: ['Channel Divinity: Twilight Sanctuary'],
          6: ['Steps of Night'],
          8: ['Divine Strike'],
          17: ['Twilight Shroud']
        }
      },
      // DRUID (2 subclasses)
      'circle_of_stars': {
        name: 'Circle of Stars',
        class: 'Druid',
        source: 'tashas',
        level: 2,
        description: 'Gain the ability to read the stars and draw on their power. You can take on luminous forms that enhance your magic.',
        features: {
          2: ['Star Map', 'Starry Form'],
          6: ['Cosmic Omen'],
          10: ['Twinkling Constellations'],
          14: ['Full of Stars']
        }
      },
      'circle_of_wildfire': {
        name: 'Circle of Wildfire',
        class: 'Druid',
        source: 'tashas',
        level: 2,
        description: 'Understand that destruction is sometimes the precursor to creation. You summon a primal spirit that helps you spread flames.',
        features: {
          2: ['Circle Spells', 'Summon Wildfire Spirit'],
          6: ['Enhanced Bond'],
          10: ['Cauterizing Flames'],
          14: ['Blazing Revival']
        }
      },
      // FIGHTER (2 subclasses)
      'psi_warrior': {
        name: 'Psi Warrior',
        class: 'Fighter',
        source: 'tashas',
        level: 3,
        description: 'Augment your physical might with psi-infused weapon strikes, telekinetic lashes, and barriers of mental force.',
        features: {
          3: ['Psionic Power'],
          7: ['Telekinetic Adept'],
          10: ['Guarded Mind'],
          15: ['Bulwark of Force'],
          18: ['Telekinetic Master']
        }
      },
      'rune_knight': {
        name: 'Rune Knight',
        class: 'Fighter',
        source: 'tashas',
        level: 3,
        description: 'Enhance your martial prowess using the supernatural power of runes, an ancient practice from giant lore.',
        features: {
          3: ['Bonus Proficiencies', 'Rune Carver', 'Giant\'s Might'],
          7: ['Runic Shield'],
          10: ['Great Stature'],
          15: ['Master of Runes'],
          18: ['Runic Juggernaut']
        }
      },
      // MONK (2 subclasses)
      'way_of_mercy': {
        name: 'Way of Mercy',
        class: 'Monk',
        source: 'tashas',
        level: 3,
        description: 'Learn to manipulate the life force of others to bring aid to those in need and harm to your foes.',
        features: {
          3: ['Implements of Mercy', 'Hand of Healing', 'Hand of Harm'],
          6: ['Physician\'s Touch'],
          11: ['Flurry of Healing and Harm'],
          17: ['Hand of Ultimate Mercy']
        }
      },
      'way_of_the_astral_self': {
        name: 'Way of the Astral Self',
        class: 'Monk',
        source: 'tashas',
        level: 3,
        description: 'Project your ki to form a spectral representation of your inner self. This astral self aids you in combat.',
        features: {
          3: ['Arms of the Astral Self'],
          6: ['Visage of the Astral Self'],
          11: ['Body of the Astral Self'],
          17: ['Awakening of the Astral Self']
        }
      },
      // PALADIN (2 subclasses)
      'oath_of_glory': {
        name: 'Oath of Glory',
        class: 'Paladin',
        source: 'tashas',
        level: 3,
        description: 'Believe that you and your friends are destined for glory through deeds of heroism. You train diligently to be legend in the making.',
        oathSpells: {
          3: ['Guiding Bolt', 'Heroism'],
          5: ['Enhance Ability', 'Magic Weapon'],
          9: ['Haste', 'Protection from Energy'],
          13: ['Compulsion', 'Freedom of Movement'],
          17: ['Commune', 'Flame Strike']
        },
        features: {
          3: ['Channel Divinity: Peerless Athlete', 'Channel Divinity: Inspiring Smite'],
          7: ['Aura of Alacrity'],
          15: ['Glorious Defense'],
          20: ['Living Legend']
        }
      },
      'oath_of_the_watchers': {
        name: 'Oath of the Watchers',
        class: 'Paladin',
        source: 'tashas',
        level: 3,
        description: 'Sworn to protect the mortal world from extraplanar threats. You stand vigilant against fiends, aberrations, and fey.',
        oathSpells: {
          3: ['Alarm', 'Detect Magic'],
          5: ['Moonbeam', 'See Invisibility'],
          9: ['Counterspell', 'Nondetection'],
          13: ['Aura of Purity', 'Banishment'],
          17: ['Hold Monster', 'Scrying']
        },
        features: {
          3: ['Channel Divinity: Watcher\'s Will', 'Channel Divinity: Abjure the Extraplanar'],
          7: ['Aura of the Sentinel'],
          15: ['Vigilant Rebuke'],
          20: ['Mortal Bulwark']
        }
      },
      // RANGER (2 subclasses)
      'fey_wanderer': {
        name: 'Fey Wanderer',
        class: 'Ranger',
        source: 'tashas',
        level: 3,
        description: 'Walk the line between the Feywild and the Material Plane. You possess a mysterious, otherworldly presence.',
        features: {
          3: ['Dreadful Strikes', 'Fey Wanderer Magic', 'Otherworldly Glamour'],
          7: ['Beguiling Twist'],
          11: ['Fey Reinforcements'],
          15: ['Misty Wanderer']
        }
      },
      'swarmkeeper': {
        name: 'Swarmkeeper',
        class: 'Ranger',
        source: 'tashas',
        level: 3,
        description: 'Bonded to a swarm of nature spirits. These spirits help you in battle and movement, gathering around you like a cloak.',
        features: {
          3: ['Gathered Swarm', 'Swarmkeeper Magic'],
          7: ['Writhing Tide'],
          11: ['Mighty Swarm'],
          15: ['Swarming Dispersal']
        }
      },
      // ROGUE (2 subclasses)
      'phantom': {
        name: 'Phantom',
        class: 'Rogue',
        source: 'tashas',
        level: 3,
        description: 'Walk the line between life and death. You gain the ability to communicate with the dead and channel necrotic energy.',
        features: {
          3: ['Whispers of the Dead', 'Wails from the Grave'],
          9: ['Tokens of the Departed'],
          13: ['Ghost Walk'],
          17: ['Death\'s Friend']
        }
      },
      'soulknife': {
        name: 'Soulknife',
        class: 'Rogue',
        source: 'tashas',
        level: 3,
        description: 'Strike with blades formed from your own psychic energy. You can telepathically communicate and use psionic powers.',
        features: {
          3: ['Psionic Power', 'Psychic Blades'],
          9: ['Soul Blades'],
          13: ['Psychic Veil'],
          17: ['Rend Mind']
        }
      },
      // SORCERER (2 subclasses)
      'aberrant_mind': {
        name: 'Aberrant Mind',
        class: 'Sorcerer',
        source: 'tashas',
        level: 1,
        description: 'Your innate magic comes from an alien influence. You wield psionic power and can reshape your spells with psionic energy.',
        features: {
          1: ['Psionic Spells', 'Telepathic Speech'],
          6: ['Psionic Sorcery', 'Psychic Defenses'],
          14: ['Revelation in Flesh'],
          18: ['Warping Implosion']
        }
      },
      'clockwork_soul': {
        name: 'Clockwork Soul',
        class: 'Sorcerer',
        source: 'tashas',
        level: 1,
        description: 'Your magic springs from the plane of Mechanus. You can channel the cosmic force of order to restore balance.',
        features: {
          1: ['Clockwork Magic', 'Restore Balance'],
          6: ['Bastion of Law'],
          14: ['Trance of Order'],
          18: ['Clockwork Cavalcade']
        }
      },
      // WARLOCK (2 subclasses)
      'the_fathomless': {
        name: 'The Fathomless',
        class: 'Warlock',
        source: 'tashas',
        level: 1,
        description: 'Your patron is a powerful entity of the deep seas. You can command water and call upon tentacles from the depths.',
        expandedSpellList: {
          1: ['Create or Destroy Water', 'Thunderwave'],
          3: ['Gust of Wind', 'Silence'],
          5: ['Lightning Bolt', 'Sleet Storm'],
          7: ['Control Water', 'Summon Elemental'],
          9: ['Bigby\'s Hand', 'Cone of Cold']
        },
        features: {
          1: ['Tentacle of the Deeps', 'Gift of the Sea'],
          6: ['Oceanic Soul', 'Guardian Coil'],
          10: ['Grasping Tentacles'],
          14: ['Fathomless Plunge']
        }
      },
      'the_genie': {
        name: 'The Genie',
        class: 'Warlock',
        source: 'tashas',
        level: 1,
        description: 'Your patron is a noble genie from an Elemental Plane. You gain abilities based on your genie\'s elemental nature.',
        expandedSpellList: {
          1: ['Detect Evil and Good', 'Thunderwave'],
          3: ['Phantasmal Force', 'Scorching Ray'],
          5: ['Create Food and Water', 'Wind Wall'],
          7: ['Phantasmal Killer', 'Wall of Fire'],
          9: ['Creation', 'Seeming']
        },
        features: {
          1: ['Genie\'s Vessel', 'Genie\'s Wrath'],
          6: ['Elemental Gift'],
          10: ['Sanctuary Vessel'],
          14: ['Limited Wish']
        }
      }
    },
    backgrounds: {},
    races: {},
    // [CONTENT CREATORS - FEB 2026]: Artificer class — the only official new class in 5e supplements
    // [D&D 5E TCE]: INT-based half-caster, subclass at level 3
    classes: {
      artificer: {
        id: 'artificer',
        name: 'Artificer',
        source: 'tashas',
        isCustom: false,
        hitDice: '1d8',
        primaryAbility: 'Intelligence',
        savingThrows: ['con', 'int'],
        proficiencies: {
          armor: ['Light armor', 'Medium armor', 'Shields'],
          weapons: ['Simple weapons'],
          tools: ["Thieves' tools", "Tinker's tools", 'One type of artisan\'s tools'],
          skills: {
            number: 2,
            options: ['Arcana', 'History', 'Investigation', 'Medicine', 'Nature', 'Perception', 'Sleight of Hand']
          }
        },
        spellcasting: {
          ability: 'int',
          cantrips: { 1: 2, 10: 3, 14: 4 },
          preparedSpells: true,
          spellsKnown: null,
          startLevel: 1,
          pactMagic: false,
          halfCasterRoundUp: true, // [FIX APR 2026 — AUDIT C-2]: TCoE p.9 — Artificer rounds UP for multiclass caster level
          spellbook: false,
          spellSlots: 'Half caster'
        },
        features: {
          1: ['Magical Tinkering', 'Spellcasting'],
          2: ['Infuse Item'],
          3: ['Artificer Specialist', 'The Right Tool for the Job'],
          4: ['Ability Score Improvement'],
          5: ['Artificer Specialist Feature'],
          6: ['Tool Expertise'],
          7: ['Flash of Genius'],
          8: ['Ability Score Improvement'],
          9: ['Artificer Specialist Feature'],
          10: ['Magic Item Adept'],
          11: ['Spell-Storing Item'],
          12: ['Ability Score Improvement'],
          14: ['Magic Item Savant'],
          15: ['Artificer Specialist Feature'],
          16: ['Ability Score Improvement'],
          18: ['Magic Item Master'],
          19: ['Ability Score Improvement'],
          20: ['Soul of Artifice']
        },
        featureDescriptions: {
          'Magical Tinkering': 'At 1st level, you learn how to invest a spark of magic into mundane objects. You can touch a Tiny nonmagical object and give it one of the following magical properties: emit bright light in a 5-foot radius, emit a recorded message, emit an odor or nonverbal sound, or a static visual effect on its surface.',
          'Spellcasting': 'You have studied the workings of magic and how to channel it through objects. You can cast artificer spells using Intelligence as your spellcasting ability.',
          'Infuse Item': 'At 2nd level, you gain the ability to imbue mundane items with certain magical infusions. You learn 4 artificer infusion recipes and learn additional ones at higher levels.',
          'Artificer Specialist': 'At 3rd level, you choose the type of specialist you are: Alchemist, Armorer, Artillerist, or Battle Smith.',
          'The Right Tool for the Job': "At 3rd level, you've learned how to produce exactly the tool you need. With thieves' tools or artisan's tools, you can magically create one set of artisan's tools in an unoccupied space.",
          'Tool Expertise': 'At 6th level, your proficiency bonus is doubled for any ability check you make that uses your proficiency with a tool.',
          'Flash of Genius': 'At 7th level, you gain the ability to come up with solutions under pressure. When you or another creature you can see within 30 feet makes an ability check or saving throw, you can add your Intelligence modifier to the roll.',
          'Magic Item Adept': 'At 10th level, you achieve a profound understanding of how to use and make magic items. You can attune to up to 4 magic items at once. Crafting magic items takes you a quarter of the normal time and half the normal gold.',
          'Spell-Storing Item': 'At 11th level, you can store a spell in an object. The object can cast the spell a number of times equal to twice your Intelligence modifier.',
          'Magic Item Savant': 'At 14th level, you can attune to up to 5 magic items at once. You ignore all class, race, spell, and level requirements on attuning to or using magic items.',
          'Magic Item Master': 'At 18th level, you can attune to up to 6 magic items at once.',
          'Soul of Artifice': 'At 20th level, you develop a mystical connection to your magic items. You gain a +1 bonus to all saving throws per magic item you are attuned to. If you are reduced to 0 hit points, you can end one of your artificer infusions to drop to 1 hit point instead.',
          'Ability Score Improvement': 'You can increase one ability score by 2, or two ability scores by 1, or take a feat.'
        },
        startingEquipment: [
          { choice: ['Any two simple weapons'] },
          { choice: ['A light crossbow and 20 bolts'] },
          "Thieves' tools",
          "A dungeoneer's pack"
        ],
        subclassLevel: 3,
        subclassName: 'Artificer Specialist',
        subclasses: {},
        multiclassRequirements: { intelligence: 13 },
        multiclassProficiencies: {
          armor: ['Light armor', 'Medium armor', 'Shields'],
          tools: ["Thieves' tools", "Tinker's tools"]
        }
      }
    },
    boons: {},
    // [FIX NOV 28, 2025]: Tasha's Optional Class Features
    // [WHY]: Tasha's provides optional features that replace/enhance base class abilities
    // [D&D 5E TCE]: Rangers get Primal Awareness (bonus spells) replacing Primeval Awareness
    optionalClassFeatures: {
      // Ranger - Primal Awareness (TCE p.57)
      // [PURPOSE]: Grants bonus spells that are always prepared and don't count against spells known
      Ranger: {
        primalAwareness: {
          name: 'Primal Awareness',
          replaces: 'Primeval Awareness',
          description: 'You can focus your awareness through the interconnections of nature. You know certain spells at certain Ranger levels, as shown on the table. These spells don\'t count against your number of Ranger spells known and they\'re always prepared.',
          bonusSpells: {
            3: ['Speak with Animals'],
            5: ['Beast Sense'],
            9: ['Speak with Plants'],
            13: ['Locate Creature'],
            17: ['Commune with Nature']
          }
        },
        // Deft Explorer features (TCE p.56)
        deftExplorer: {
          name: 'Deft Explorer',
          replaces: 'Natural Explorer',
          description: 'You are an unsurpassed explorer and survivor. At 1st level you gain Canny, at 6th level you gain Roving, and at 10th level you gain Tireless.',
          features: {
            1: ['Canny'],
            6: ['Roving'],
            10: ['Tireless']
          }
        },
        // Favored Foe (TCE p.56)
        favoredFoe: {
          name: 'Favored Foe',
          replaces: 'Favored Enemy',
          description: 'When you hit a creature with an attack roll, you can mark it as your favored enemy for 1 minute. The first time on each of your turns that you hit the marked target, it takes extra 1d4 damage.',
          damage: '1d4',
          scalesAt: { 6: '1d6', 14: '1d8' }
        }
      }
    }
  }
};